var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentSession.activeStepKey != 'Vehicle.Plate' && _vm.currentSession.activeStepKey != 'VehicleAlt.Confirm' )?_c('div',[_c('a',{staticClass:"back",on:{"click":function($event){return _vm.back()}}},[_vm._v("Back")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }